import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-6 border-b cursor-pointer border-neutral-100" }
const _hoisted_2 = { class: "flex items-center justify-between mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "px-2 py-[3px] ml-2 text-xs font-bold text-white bg-primary-600 rounded-[20px]"
}
const _hoisted_4 = { class: "text-sm text-neutral-600" }
const _hoisted_5 = ["innerHTML"]


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationCard',
  props: {
    title: {
        type: String,
        default: null,
    },
    date: {
        type: String,
        default: null,
    },
    description: {
        type: String,
        default: null,
    },
    notifNew: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _createElementVNode("span", {
          class: _normalizeClass([!__props.notifNew ? 'font-semibold' : ''])
        }, _toDisplayString(__props.title), 3),
        (!__props.notifNew)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "New"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.date), 1)
    ]),
    _createElementVNode("p", {
      class: "text-sm text-neutral-600 max-h-[60px] text-ellipsis overflow-hidden line-clamp-3",
      innerHTML: __props.description
    }, null, 8, _hoisted_5)
  ]))
}
}

})